import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = { class: "container-fluid" }

import { env } from '@/helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'BasePageHeader',
  setup(__props) {

const headerImg = env('PRICESHOW_HERO_IMG')
  ? env('PRICESHOW_HERO_IMG')
  : `${window.ioappConfig.themeUri}/assets/img/order/hero_bodenseeenergie.jpg`;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "background-overlay",
      style: _normalizeStyle({ backgroundImage: `linear-gradient(90deg, #FFFFFFD4 0%, #FFFFFF00 100%), url(${_unref(headerImg)})` })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, [
          _renderSlot(_ctx.$slots, "title")
        ]),
        _createElementVNode("h2", null, [
          _renderSlot(_ctx.$slots, "subtitle")
        ])
      ])
    ], 4)
  ]))
}
}

})